import { useTranslation } from 'react-i18next';

export const useTabs = () => {
  const { t } = useTranslation();
  return [
    { label: t('pages.playout_reports.tabs.overview'), to: '' },
    { label: t('pages.playout_reports.tabs.by_sponsor'), to: 'by-sponsor' },
    { label: t('pages.playout_reports.tabs.by_asset'), to: 'by-asset' },
  ];
};
